import React from "react";
import { observer } from "mobx-react-lite";
import FormHeader from "../../components/FormHeader";
import useController from "./controller";
import Ellipses from "../../components/Ellipses";
import BackButton from "../../components/BackButton";
import style from "./paymentFormStyles";
import { useTranslation } from "react-i18next";
import PaymentMethodItem from "./PaymentMethods/PaymentMethodItem";
import iconApple from "../../assets/icons/apple-logo-svgrepo-com.svg";
import BaseSpinner from "../../components/BaseSpinner";
import BaseButton from "../../components/BaseButton";

import "./style.scss";

// Провайдер выбирается автоматически по домену (ТЗ «Нью» #8) — блока «Выбери метод
// оплаты» больше нет: Prodamus открывается в iframe, на PayPlus сразу переход на их
// страницу (30.10). Кнопка остаётся только для Apple Pay в iOS WebView.
export default observer(function PaymentPage() {
  const {
    formLink,
    errorMessage,
    isApplePayFlow,
    handleBuyInAppWebViewClick,
    returnStatus,
    canRetry,
    isPaymentSlow,
    retryPayment,
    goToPersonalAccount,
  } = useController();
  const { t } = useTranslation();

  return (
    <div className="payment-page">
      <Ellipses countEllipses={1} className="payment-page-ellipse" />
      {/* после возврата с PayPlus страница загружена заново, и «Назад» без истории
          увёл бы на корень сайта (на in-touch.space это WordPress), поэтому в ЛК */}
      <BackButton onClick={returnStatus ? goToPersonalAccount : undefined} />
      <FormHeader
        containerClass="payment-page__form-header"
        title={t("payment_page.title")}
        titleClass="payment-page__title"
      />
      {isApplePayFlow && (
        <div className="payment_method">
          <PaymentMethodItem
            title={t("payment_page.paymentInApple")}
            text=""
            icon={iconApple}
            onClick={handleBuyInAppWebViewClick}
          />
        </div>
      )}
      {formLink && (
        <div className="form-payment">
          {/* allow="payment" — без него браузер блокирует Payment Request API
              (Apple Pay / Google Pay) внутри iframe, остаётся только форма карты */}
          <iframe
            title="payment"
            style={style.payFormIframe}
            src={formLink}
            allow="payment"
          ></iframe>
        </div>
      )}
      {/* 04.10: пока создаётся ссылка на оплату (запрос к PayPlus может занять до ~15 с
          при повторе на другой адрес) — спиннер, а не пустая страница */}
      {!returnStatus && !formLink && !errorMessage && !isApplePayFlow && (
        <div className="payment-page__loader">
          <BaseSpinner />
        </div>
      )}
      {/* 30.10: вернулись со страницы PayPlus с оплатой, ждём подтверждения */}
      {returnStatus === "success" && (
        <div className="payment-page__result">
          {isPaymentSlow ? (
            <>
              <div>{t("payment_page.pending_long")}</div>
              <BaseButton onClick={goToPersonalAccount}>
                {t("payment_page.to_account")}
              </BaseButton>
            </>
          ) : (
            <>
              <BaseSpinner />
              <div>{t("payment_page.checking")}</div>
            </>
          )}
        </div>
      )}
      {returnStatus && returnStatus !== "success" && (
        <div className="payment-page__result">
          <div>{t("payment_page.failed")}</div>
          {canRetry && (
            <BaseButton onClick={retryPayment}>
              {t("payment_page.retry")}
            </BaseButton>
          )}
          <BaseButton unfilled={canRetry} onClick={goToPersonalAccount}>
            {t("payment_page.to_account")}
          </BaseButton>
        </div>
      )}
      {/* fix: заказ не создался (например, +57 без связанной игры) — вместо пустой
          страницы показываем причину, а не «висим» с одним заголовком */}
      {!formLink && errorMessage && (
        <div className="payment-page__error">{errorMessage}</div>
      )}
    </div>
  );
});
